import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'users-and-roles.actors-table.permission-gate-view.header',
		defaultMessage: 'Where is everybody?',
		description: 'Header text for permission gated screen when there are no actors in project.',
	},
	addPeopleDescription: {
		id: 'users-and-roles.actors-table.permission-gate-view.add-people-description',
		defaultMessage:
			"On a free plan, you can only add people using your site's administration settings. Upgrade your plan to better control who can access this project.",
		description:
			'Description to standard project admin when there are no actors in a Free plan but mentioning that upgrading the plan will provide better control.',
	},
	addPeopleAdminDescription: {
		id: 'users-and-roles.actors-table.permission-gate-view.add-people-admin-description',
		defaultMessage:
			"On a free plan, you can only add people using your site's {adminSettingsLink}. Upgrade your plan to better control who can access this project.",
		description:
			'Description to site admin when there are no actors in a Free plan but mentioning that upgrading the plan will provide better control.',
	},
	administerSettings: {
		id: 'users-and-roles.actors-table.permission-gate-view.administer-settings',
		defaultMessage: 'administration settings',
		description: 'Administer settings link',
	},
	learnMoreAboutPlans: {
		id: 'users-and-roles.actors-table.permission-gate-view.learn-more-about-plans',
		defaultMessage: 'Learn more about plans',
		description: 'learn more about plan',
	},
	upgradePlan: {
		id: 'users-and-roles.actors-table.permission-gate-view.upgrade-plan',
		defaultMessage: 'Upgrade your plan',
		description:
			'Call to action that will appear in the sentence: "Upgrade your plan to customize project permissions". ' +
			'A plan is the edition or tier of the product that the admin is currently subscribed to.',
	},
});
